import { FunctionComponent, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAdminScope } from '~/api/admin/admin-scope.api'
import { useAdminSites } from '~/api/admin/admin-site.api'
import { useLazyQuery } from '~/api/api-client'
import { downloadCSVData } from '~/utils/fileDownload'
import { PureAdminScopeSites } from './PureAdminScopeSites'

export const AdminScopeSites: FunctionComponent = () => {
  // State
  const [search, setSearch] = useState<string>('')

  // Context
  const { scopeId } = useParams()

  // API hooks
  const { data: scope, isLoading: isScopeLoading } = useAdminScope(scopeId)
  const { data: sites, isLoading: isSitesLoading, isRefetching: isSitesRefetching } = useAdminSites(scopeId ?? '', search)
  const { fetch: fetchSiteAsCsv } = useLazyQuery<string>({ url: `/admin/scopes/${scopeId}/sites?format=csv`, keys: ['app', 'tags', 'csv'] })

  const downloadCSV = async () => {
    const { data: sitesAsCsv } = await fetchSiteAsCsv()

    if (sitesAsCsv) downloadCSVData(sitesAsCsv, `sites-${scopeId}`)
  }

  return <PureAdminScopeSites scope={scope} sites={sites} isLoading={isScopeLoading || isSitesLoading || isSitesRefetching} onDownload={downloadCSV} onSearch={(search) => setSearch(search)} />
}
